module.exports = __webpack_public_path__ + "static/media/7.jpg.a2dbea63.webp";